import { Button } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

const Index = () => {
  return (
    <WhiteButton href="https://about.utoniq.com/contact">
      お問い合わせ
    </WhiteButton>
  )
}

export default Index

const WhiteButton = styled(Button)({
  background: '#FFF',
  borderRadius: 25,
  paddingTop: 5,
  paddingBottom: 5,
  lineHeight: '1.75',
  textTransform: 'none',
  border: '2px solid #263238',
  fontWeight: 600,
  width: 250,
  fontSize: 16,
  color: '#263238',
})
